<template>
  <manage type="qtwj"></manage>
</template>

<script>
import Manage from './manage'

export default {
  components: {
    Manage
  }
}
</script>
